import { render, staticRenderFns } from "./WindSpeedCard.vue?vue&type=template&id=273d5158&"
import script from "./WindSpeedCard.vue?vue&type=script&lang=js&"
export * from "./WindSpeedCard.vue?vue&type=script&lang=js&"
import style0 from "./WindSpeedCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports